import { expVal } from '@confluence/feature-experiments';

export function isRelayEnabled(): boolean {
	return (
		process.env.BUILD_VARIANT === 'relay' ||
		expVal('confluence_apollo_to_relay_migration', 'isEnabled', false)
	);
}
